<template>
  <div id="search">
    <a-row class="searchbox" :gutter="20">
      <a-col :span="18">
        <div class="inputborder">
          <input class="searchinput" v-model="searchinput" placeholder="请输入学号/姓名/部门" />
        </div>
      </a-col>
      <a-col class="textleft" :span="6">
        <!-- <a-button class="searchbtn" type="danger" icon="search" round>查询</a-button> -->
        <a-button type="danger" @click="search" shape="round" icon="search">查询</a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import Axios from "@/Axios";
export default {
  name: "Search",
  data() {
    return {
      searchinput: "",
      url: {
        studentscore: "/tscore/yhaScore/page/studentscore",
      },
    };
  },
};
</script>
<style>
#search {
  /* height: 8vh; */
}
.searchbox {
  /* height: 5vh; */
  display: flex;
  align-items: center;
}
.searchinput {
  outline: none;
  width: 96%;
  height: 80%;
  background-color: #f1f1f1;
  border: none;
}
.searchinput::-webkit-input-placeholder {
  text-align: center;
}
.inputborder {
  /* outline: none; */
  width: 100%;
  height: 5vh;
  font-size: 20px;
  background-color: #f1f1f1;
  border-radius: 4vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.textleft {
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Search/Search.vue